<template>
<div class="timeline-item">
    <div class="timeline-item__date">Mar 15</div>
    <div class="circle"></div>
    <div class="timeline-item__details">
        <div class="activity-title">Niagara Falls Viewing</div>
        <div class="time">9am to 11am</div>
        <div class="activity-location">Niagara Falls, Ontario, Canada</div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'TimelineItem'
    }
</script>

<style scoped lang="scss">
    .timeline-item {
        position: relative;
        display: flex;
        margin-top: 52px;
        font-family: 'Montserrat', sans-serif;
        font-weight: $light;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }

    .timeline-item:not(:last-child):not(.no-line)::before {
        content: "";
        background-color: $light-blue;
        display: block;
        position: absolute;
        width: 2px;
        z-index: 0;

        @media all and (min-width: $breakpoint + 1) {
            left: calc(50px + 24px + 11px);
            height: calc(100% + 52px);
        }

        @media all and (max-width: $breakpoint) {
            left: calc(50px + 8px + 11px);
            height: calc(100% + 20px);
        }
    }


    .timeline-item .circle {
        background-color: $accent;
        position: relative;
        width: 24px;
        height: 24px;
        border: 5px solid $light-blue;
        border-radius: 50%;
        flex-shrink: 0;
    }


    .timeline-item__date {
        flex-shrink: 0;
        margin: 5px 24px 0 0;
        width: 50px;
        text-transform: uppercase;
        font-size: 12px;

        @media all and (max-width: $breakpoint) {
            margin-right: 8px;
        }
    }


    .timeline-item__details {
        margin-left: 20px;
    }


    .activity-title {
        font-weight: $semibold;
        font-size: 20px;

        @media all and (max-width: $breakpoint) {
            font-size: 14px;
        }
    }


    .time {
        margin-top: 4px;
        text-transform: uppercase;
        font-weight: $semibold;
        color: $accent-two;
    }

    .time,
    .activity-location {
        line-height: 18px;

        @media all and (max-width: $breakpoint) {
            font-size: 12px;
        }
    }
</style>
